module.exports = __webpack_public_path__ + "static/media/blue-information.88937ab0.svg";